module.exports = __webpack_public_path__ + "img/patient_cal.5e7efd81.png";